module.exports = __webpack_public_path__ + "img/14.7fe8ace1.png";